import React, {Component} from 'react';
import {Button} from 'semantic-ui-react';
import Utils from 'utils/Utils.js';
import Portal from 'modules/misc/Portal.js';

const transitionTimeMs = 250
const s={
    popup:{
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: '100%',
        left:'0',
        zIndex: '1000',
        backgroundColor:'#fff',
        transition: 'top ease ' + transitionTimeMs+'ms',
    },
    closeButton: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        fontSize: '1.5em',
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        border: 'none',
        padding: '0',
        zIndex: '2000',
    },
    closeIcon: {
        color: '#fff',
        textShadow: '0px 3px 2px rgba(0,0,0,0.25)',
    },
    titleBar: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '50px',
        backgroundColor: 'rgba(0,0,0,0.25)',
        background: 'linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.25))',
    }
}


class SlidingPopup extends Component {
    constructor(props) {
        super(props);
        this.divMounted = this.divMounted.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentWillMount() {
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow  = 'hidden';
    }

    componentDidMount() {
        Utils.delay(10).then(()=>{
            if(this.div) {
                this.div.style.top = '0';
            }
        });
    }


    componentWillUnmount() {
        document.body.style.overflow = this.bodyOverflow;
    }

    divMounted(ref) {
        this.div = ref;
    }

    onClick(){
        if(this.div) {
            this.div.style.top = '100%';
        }
        Utils.delay(transitionTimeMs).then(this.props.onClose);
    }

    render() {
        var {style, children, onClose} = this.props;
        return (
            <Portal>
                <div ref={this.divMounted} style={{...s.popup, ...style}}>
                    <div style={{zIndex: '5000', position: 'relative', width: '100%', height:'100%'}}>
                    {children}
                    {onClose &&
                        <div style={s.titleBar}>
                            <Button style={s.closeButton} onClick={this.onClick}>
                                <i style={s.closeIcon} className='icon-x'/>
                            </Button>
                        </div>
                    }
                    </div>
                </div>
            </Portal>
        );
    }

}

export default SlidingPopup;



// WEBPACK FOOTER //
// ./src/modules/misc/SlidingPopup.js